// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"7":"ProfilePage","378":"PaymentSucceeded","897":"MainPage","970":"MessagesPage"}[chunkId] + "." + {"7":"296b3311","378":"a556f4bb","897":"fdd18170","970":"3fb3f9aa"}[chunkId] + ".chunk.css";
};